import cookie from '@/common/utils/cookie'
import _ from 'lodash'
import { eventBodyListParser } from '@/common/utils/gnb.fp'
import { getMypurchaseProducts } from '@/common/utils/request'

function doNotInitializeAdbrix () {
  return window.adbrix === undefined
}
function sendLoginLog (userNo) {
  if (doNotInitializeAdbrix()) return
  window.adbrix.login(userNo)
}

function sendLogoutLog () {
  if (doNotInitializeAdbrix()) return
  window.adbrix.logout()
}

function sendSearchEvent ({ targetCellList = [], searchWord = '' }) {
  const signupType = cookie.getLoginType()
  const itemList = targetCellList.map((cell) => {
    const eventItem = _.get(cell, 'event_list', []).filter((eventItemList) => {
      const parsedListItem = eventBodyListParser(eventItemList)
      const keyList = Object.keys(parsedListItem)
      return keyList.some((key) => {
        return key === 'uiparent'
      })
    })
    const event = _.get(eventItem, '0', null)
    let uiParent = ''
    let uiCode = ''
    if (event !== null) {
      const eventObject = eventBodyListParser(event)
      uiParent = _.get(eventObject, 'uiparent')
      uiCode = _.get(eventObject, 'uicode')
    }
    return {
      category: uiParent,
      productId: uiCode,
      productName: _.get(cell, 'title_list', []).map((title) => {
        return _.get(title, 'text', '').split('$O$').join('')
      }).join(' ')
    }
  })
  const searchProductList = itemList.map((searchItem) => {
    const { category, productId, productName } = searchItem
    const searchCategory = window.adbrix.commerceAttr.categories(category)
    return window.adbrix.commerceAttr.product(
      productId,
      productName,
      0,
      1,
      0,
      'KRW',
      searchCategory,
      {
        pg_amount: 1,
        coin_amount: 0,
        promotion_id: '',
        payment_method: 'ETC',
        creditcard_type: ''
      }
    )
  })
  searchProductList.map((searchProduct) => {
    _.set(searchProduct, 'keyword', searchWord)
    _.set(searchProduct, 'signup_route', signupType)
    window.adbrix.event.send('search_event', searchProduct)
  })
}
// INFO: 반드시 로그인 후 cs 정보가 cookie에 setting 된 뒤에 실행시켜야 됨
function setUserProduct () {
  getMypurchaseProducts({ startdate: '', enddate: '', producttype: 'pass', autopayment: 'y', offet: 0, limit: 20, orderby: 'new' }).then(({ data }) => {
    const voucherList = _.get(data, 'list', [])
    voucherList.map((voucher, index) => {
      const productId = _.get(voucher, 'productid', '')
      const productName = _.get(voucher, 'productname', '')
      window.adbrix.userProperty.addOrUpdate(`productid_${index + 1}`, productId)
      window.adbrix.userProperty.addOrUpdate(`productname_${index + 1}`, productName)
    })
  })
}

export default {
  sendLoginLog,
  sendLogoutLog,
  sendSearchEvent,
  setUserProduct
}
